






















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class extends Vue {
    @Prop({ required: true, default: false })
    public isOpen: boolean;

    @Prop({ required: true })
    public title: string;

    @Prop({ required: true })
    public message: string;

    @Prop({ required: false, default: 350 })
    public width: number;

    public internalIsOpen: boolean = false;

    public mounted() {
        this.internalIsOpen = this.isOpen;
    }

    public handleYes() {
        this.$emit('yes');
    }

    public handleNo() {
        this.$emit('no');
    }
}
